// extracted by css-extract-rspack-plugin
export default {"content":"src-pages-admin-CilogonSetup-module__content-myYttT","sectionTitle":"src-pages-admin-CilogonSetup-module__sectionTitle-L83GhP","externalLink":"src-pages-admin-CilogonSetup-module__externalLink-M8pYs0","figure":"src-pages-admin-CilogonSetup-module__figure-lkPyal","screenshotWrapper":"src-pages-admin-CilogonSetup-module__screenshotWrapper-x8diN_","screenshot":"src-pages-admin-CilogonSetup-module__screenshot-Wi83uh"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"content\":\"src-pages-admin-CilogonSetup-module__content-myYttT\",\"sectionTitle\":\"src-pages-admin-CilogonSetup-module__sectionTitle-L83GhP\",\"externalLink\":\"src-pages-admin-CilogonSetup-module__externalLink-M8pYs0\",\"figure\":\"src-pages-admin-CilogonSetup-module__figure-lkPyal\",\"screenshotWrapper\":\"src-pages-admin-CilogonSetup-module__screenshotWrapper-x8diN_\",\"screenshot\":\"src-pages-admin-CilogonSetup-module__screenshot-Wi83uh\"}";
        // 1793732399192
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  